import React, { type FC, type PropsWithChildren } from 'react';
import { DH } from '../../../utils/DataHook';
import { Text } from '../../Text';
import s from './styles.scss';

export const NoWrapContainer: FC<PropsWithChildren<{}>> = ({ children }) => {
  return <Text className={s.noWrapContainer}>{children}</Text>;
};

export const Container: FC<PropsWithChildren<{ dataHook: string }>> = ({ dataHook, children }) => {
  return (
    <div data-hook={dataHook} className={s.container}>
      {children}
    </div>
  );
};

export const LogoWrap: FC<PropsWithChildren<{}>> = ({ children }) => {
  return (
    <span data-hook={DH.PaymentMethodView.Logo} className={s.logo}>
      {children}
    </span>
  );
};
